import axios from 'axios'
import { Toast } from 'vant'
import { getLanguage } from '@/utils/lang'
import { getToken } from '@/utils/auth'

// 语言代码映射（将显示值转换为标准语言代码）
const langCodeMap = {
    'En': 'en',
    '中': 'zh-CN',
    'zh-CN': 'zh-CN',
    'zh': 'zh-CN',
    'العربية': 'ar',
    '日': 'ja',
    'en': 'en'
}

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 300000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // 设置请求头
        config.headers = config.headers || {}
        let language = getLanguage()
            // 如果语言是显示值，转换为标准语言代码
        if (langCodeMap[language]) {
            language = langCodeMap[language]
        }
        config.headers['Accept-Language'] = language
        const token = getToken()
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        if (res.code === 90000) { // 90000  第三方登录失败不进行报错提示
            return res
        }

        // 处理行为验证码的code
        if (res.repCode === '0000') {
            return res
        }

        if (res.code !== 0) {
            Toast.fail(res.message || 'Error')
            return Promise.reject(res)
        }
        return res
    },
    error => {
        console.log(error.response) // for debug
        Toast.fail(error.response.data.message || 'Error')
        return Promise.reject(error)
    }
)

const get = function(url, params, errorMsg) {
    return service({
        headers: { 'errorMsg': errorMsg || true },
        url,
        method: 'get',
        params
    })
}

const post = function(url, params) {
    return service({
        url,
        method: 'post',
        data: params
    })
}

export const request = service

export default {
    request,
    get,
    post
}